import get from 'lodash/get';
import {
  HIDE_ERRORS,
  HIDE_WARNINGS,
  SHOW_REMOVED_ADS,
  SHOW_REMOVED_CAMPAIGNS
} from '../actions/types';

export default (state = {
  hideErrors: [],
  hideWarnings: [],
  showRemovedAds: false,
  showRemovedCampaigns: false
}, action) => {
	switch (action.type) {
		case HIDE_ERRORS: {
      const errors = get(state, 'hideErrors', []);
      const accounts = errors.includes(action.payload) ? errors : [...errors, action.payload];
			return { ...state, hideErrors: accounts };
    }
    case HIDE_WARNINGS: {
      const warnings = get(state, 'hideWarnings', []);
      const accounts = warnings.includes(action.payload) ? warnings : [...warnings, action.payload];
			return { ...state, hideWarnings: accounts };
    }
    case SHOW_REMOVED_ADS: {
      const showRemovedAds = get(state, 'showRemovedAds', false);
      return { ...state, showRemovedAds: !showRemovedAds };
    }
    case SHOW_REMOVED_CAMPAIGNS: {
      const showRemovedCampaigns = get(state, 'showRemovedCampaigns', false);
      return { ...state, showRemovedCampaigns: !showRemovedCampaigns };
    }
		default:
			return state;
	}
};
